module.exports = __webpack_public_path__ + "static/media/quiz360.2e2df77f.svg";